module.exports = __webpack_public_path__ + "static/media/HCMM401.7bbf59fc.jpg";